import { Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { stringify } from 'node:querystring';
import { map, switchMap } from 'rxjs/operators';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { mspGlobal } from '../../global/mspGlobal';
import { LabelsInterface } from './data/label.inteface';

@Injectable({
	providedIn: 'root',
})
export class LabelsService {
	private getLabelUrl = environment.baseApiUrl + 'tool/label?language={qryString}';
	private islogged_getLabelUrl = environment.baseApiUrl + 'tool/label?isLogged=true&language={qryString}';
	private postLabelUrl = environment.baseApiUrl + 'tool/label';
	private putLabelUrl = environment.baseApiUrl + 'tool/label';
	private getLabelLoadUrl = environment.baseApiUrl + 'tool/label/all';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService,
		private profileService: ProfileService,
		private mspGlobal: mspGlobal
	) {}

	labels: WritableSignal<LabelsInterface> = signal({});

	getUserLanguage(): Observable<string> {
		return this.profileService.setLocalUser().pipe(
			map((userData) => {
				return userData.language;
			})
		);
	}

	getLabels(): Observable<LabelsInterface> {
		if (Object.keys(this.mspGlobal.labels).length > 0) return of(this.mspGlobal.labels);

		let getLabelUrl = this.getLabelUrl;
		if (this.AuthLoginService.isLoggedIn()) {
			return this.getUserLanguage().pipe(
				switchMap((userLanguage) => {
					const headers = new HttpHeaders({
						Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
						'Content-Type': 'application/json;charset=UTF-8',
					});
					const getLabelUrl = this.islogged_getLabelUrl.replace('{qryString}', userLanguage);
					return this.http.get<LabelsInterface>(getLabelUrl, { headers: headers }).pipe(
						map((labels) => {
							this.labels.set(labels);
							return this.labels();
						})
					);
				})
			);
		} else {
			switch (navigator.language.split('-')[0]) {
				case 'pt': {
					getLabelUrl = getLabelUrl.replace('{qryString}', 'Portuguese');
					break;
				}

				case 'es': {
					getLabelUrl = getLabelUrl.replace('{qryString}', 'Spanish');
					break;
				}

				case 'zh': {
					getLabelUrl = getLabelUrl.replace('{qryString}', 'Chinese');
					break;
				}

				case 'chi': {
					getLabelUrl = getLabelUrl.replace('{qryString}', 'Chinese');
					break;
				}

				case 'sk': {
					getLabelUrl = getLabelUrl.replace('{qryString}', 'Slovak');
					break;
				}

				case 'it': {
					getLabelUrl = getLabelUrl.replace('{qryString}', 'Slovak');
					break;
				}

				default: {
					getLabelUrl = getLabelUrl.replace('{qryString}', 'English');
					break;
				}
			}

			return this.http.get<LabelsInterface>(getLabelUrl).pipe(
				map((labels) => {
					this.labels.set(labels);
					return this.labels();
				})
			);
		}
	}

	postLabel(body: any): Observable<LabelsInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.post<LabelsInterface>(this.postLabelUrl, body, { headers: headers }).pipe(
			map((labels) => {
				this.labels.set(labels);
				return this.labels();
			})
		);
	}

	putLabel(body: any): Observable<LabelsInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.put<LabelsInterface>(this.putLabelUrl, body, { headers: headers }).pipe(
			map((labels) => {
				this.labels.set(labels);
				return this.labels();
			})
		);
	}

	getLabelLoad(): Observable<LabelsInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<LabelsInterface[]>(this.getLabelLoadUrl, { headers: headers }).pipe(
			map((labelLoad) => {
				const newLabelLoad: LabelsInterface[] = [];
				for (const label of labelLoad) {
					const newLabel: LabelsInterface = {
						id: label.id.startsWith('lbl_') ? label.id.slice(4) : label.id,
						portuguese: label.portuguese,
						english: label.english,
						spanish: label.spanish,
						slovak: label.slovak,
						chinese: label.chinese,
						italian: label.italian,
					};

					newLabelLoad.push(newLabel);
				}

				return newLabelLoad;
			})
		);
	}
}
